/**
 * Client-side mirror of API upload allowlist (team-file-rules.ts).
 * Keep in sync when adding/removing types.
 */

const ALLOWED_EXTENSIONS = new Set([
  "png",
  "jpg",
  "jpeg",
  "webp",
  "gif",
  "mp4",
  "webm",
  "pdf",
  "txt",
  "md",
  "csv",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "pptx",
]);

/** Comma-separated accept= value for file inputs */
export const TEAM_FILE_ACCEPT =
  ".png,.jpg,.jpeg,.webp,.gif,.mp4,.webm,.pdf,.txt,.md,.csv,.doc,.docx,.xls,.xlsx,.pptx";

export const TEAM_FILE_TYPES_HINT =
  "images, short video, PDF, text/CSV, or Office (.doc, .docx, .xls, .xlsx, .pptx)";

export function extensionOf(filename) {
  const base = String(filename || "").split(/[/\\]/).pop() || "";
  const i = base.lastIndexOf(".");
  if (i <= 0) return "";
  return base.slice(i + 1).toLowerCase();
}

export function baseNameOf(filename) {
  const base = String(filename || "").split(/[/\\]/).pop() || "";
  const i = base.lastIndexOf(".");
  if (i <= 0) return base;
  return base.slice(0, i);
}

/** Keep the original file extension when renaming. */
export function preserveFileExtension(currentName, requestedName) {
  const ext = extensionOf(currentName);
  const cleaned = String(requestedName || "")
    .trim()
    .replace(/[/\\]/g, "_");
  if (!ext) return cleaned;
  const stem = baseNameOf(cleaned).trim() || "file";
  return `${stem}.${ext}`;
}

/**
 * @param {string} filename
 * @param {string} [mimeType]
 */
export function isAllowedTeamFileUpload(filename, mimeType) {
  const ext = extensionOf(filename);
  if (!ext || !ALLOWED_EXTENSIONS.has(ext)) return false;
  if (ext === "svg") return false;
  // MIME is best-effort in the browser; extension is the gate (matches API empty-mime path)
  void mimeType;
  return true;
}
